export default __webpack_public_path__ + "static/6894-ad97530335e65d8333a3671e68e16f7c.jpg";